import React, { useEffect, useState } from 'react'
// import commonStyles from "../ReviewApproveForms.styles"
import SelectDropdown from '../../../../components/dropdown/selectdropdown/SelectDropdown';
import Button from '../../../../components/button/Button';
import RichGrid from '../../../../components/richgrid/RichGrid';
import Label from '../../../../components/label/Label';
import Icons from '../../../../components/icons/Icons'
import { VEC_ICON_NAME } from '../../../../components/icons/constants'

import { setApproveFormsModal, setDownloadAllPDFModal, setMergePdfCheckbox, setPaginationState, setRejectFormRemark, setRejectFormsModal, setSelected1099FormsGrid, setSelectedForm, setSelectedPayer, setSelectedStatus, setSelectedTaxYear, setPayerDropdownPagination } from './Forms1099Slice';
import { useDispatch, useSelector } from 'react-redux';
import { componentKey } from "./Forms1099Slice"
import { LABEL_WEIGHT } from '../../../../components/label/constants';
import { ROW_SELECTION_OPTIONS } from '../../../../components/richgrid/constants';
import useGarbageCollector from '../../../../../libs/garbagecollector/garbageCollectorHooks';
import { EDIT_FORM_ORIGIN, FORM_SECTION_ROUTES, QUERY_PARAMS } from '../../constants';
import { addNotifications } from '../../../toaster/ToasterPortalSlice';
import CheckboxWLabel from '../../../../components/checkbox/checkboxwlabel/CheckboxWLabel';
import Loadable from '../../../../components/loadable/Loadable';
import { approveForm, get1099FormStatuses, getFormsListAndTaxYears, getReviewApprovePayers, rejectForm, reviewAndApproveGridData, reviewApproveFormsDownloadAllPDF, reviewApproveFormsExportToExcel, viewPDF } from './Forms1099Saga';
import Payer from '../../../../../libs/utility/Payer';
import { BUTTON_TYPE } from '../../../../components/button/constants';
import ConfirmationPopup from '../../../../components/popup/confirmationpopup/ConfirmationPopup';
import TextArea from '../../../../components/input/textarea/TextArea';
import Popup from '../../../../components/popup/Popup';
import commonStyles from "../../FormSection.styles"
import { FORM_STATUS, REVIEW_AND_APPROVE_FORMS_LOADING_STATES, REVIEW_AND_APPROVE_FORMS_MESSAGE_MAP, REVIEW_APPROVE_FORMS_LOADING_STATES } from '../constants';
import { COMMON_LOADING_STATES } from '../../../constants/constants';
import useTxSearchParams from '../../../../../libs/txsearchparams/TxSearchParamsHook';
import useTxNavigate from '../../../../../libs/txnavigate/TxNavigateHook';
import General from '../../../../../libs/utility/General';
import useFormatTIN from '../../../../../libs/customhooks/useFormatTIN';

const Forms1099 = () => {
    useGarbageCollector(componentKey);

    const dispatch = useDispatch();
    const navigate = useTxNavigate();

    const [queryParams, setQueryParams] = useTxSearchParams();

    const { loadingState, statusList, selectedStatus, formsList, selectedForm, taxYears, selectedTaxYear, payersList, selectedPayer, $1099FormsGrid, selected1099Forms, paginationState, downloadAllPDFModal, approveFormsModal, rejectFormsModal, rejectFormRemark, mergePdfCheckbox, gridDataLoadingState, payerDropdownPagination } = useSelector(state => state[componentKey]);
    const { formatTIN } = useFormatTIN();
    const [paginatedPayerList, setPaginatedPayerList] = useState([]);

    useEffect(() => {
        setPaginatedPayerList(payersList)
    }, [payersList])

    useEffect(() => {
        const urlStatus = queryParams.get(QUERY_PARAMS.STATUS);
        const urlFormId = queryParams.get(QUERY_PARAMS.FORM_ID);
        const urlTaxYear = queryParams.get(QUERY_PARAMS.TAX_YEAR);

        dispatch(get1099FormStatuses({ status: urlStatus }));
        dispatch(getFormsListAndTaxYears({ formId: urlFormId, taxYear: urlTaxYear }));
    }, []);

    useEffect(() => {
        const urlPayerId = queryParams.get(QUERY_PARAMS.PAYER_ID);

        if (selectedForm?.value) {
            dispatch(getReviewApprovePayers({
                formId: selectedForm?.value,
                payerId: urlPayerId,
                paginationState,
                taxyear: selectedTaxYear?.value,
                formstatus: selectedStatus?.status
            }))
        }
    }, [selectedForm]);

    const MANAGE_1099_FORMS_COLUMN = [
        {
            field: "Date",
            header: <Label weight={LABEL_WEIGHT[700]} customStyles={{ ...commonStyles.text, ...commonStyles.date }}>Date</Label>,
            renderLogic: (row, idx) => <span style={{ ...commonStyles.text, ...commonStyles.date }}>{row?.Date || "-"}</span>
        },
        {
            field: "TIN",
            header: <Label weight={LABEL_WEIGHT[700]}>TIN</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{formatTIN(row.TINType, row.TIN) || "-"}</span>
        },
        {
            field: "Name",
            header: <Label weight={LABEL_WEIGHT[700]}>Name</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row?.Name || "-"}</span>
        },
        {
            field: "Amount",
            header: <Label weight={LABEL_WEIGHT[700]}>Amount ($)</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row?.Amount || "-"}</span>
        },
        {
            field: "RecipientEmail",
            header: <Label weight={LABEL_WEIGHT[700]}>Recipient Email</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row?.RecipientEmail || "-"}</span>
        },
        {
            field: "RecipientClientId",
            header: <Label weight={LABEL_WEIGHT[700]}>Recipient Client ID</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row?.ClientRecipientId || "-"}</span>
        },
        {
            field: "DataEntryUserEmail",
            header: <Label weight={LABEL_WEIGHT[700]}>Data Entry User Email</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row?.MemberEmail || "-"}</span>
        },
        {
            field: "Status",
            header: <Label weight={LABEL_WEIGHT[700]}>Status</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row?.Status || "-"}</span>
        },
        {
            field: "Remarks",
            header: <Label weight={LABEL_WEIGHT[700]}>Remarks</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{"-"}</span>
        },
        {
            field: "operations",
            header: <Label Label weight={LABEL_WEIGHT[700]} >Operations</Label >,
            renderLogic: (row, idx) => <div style={commonStyles.actionButtons}>
                <Loadable currentState={loadingState.state} loadingStates={[`${REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_VIEW_PDF_LIST_LOADING}-${row?.FormId}`]} messageMap={REVIEW_AND_APPROVE_FORMS_MESSAGE_MAP} isNewLoadable={true} isFullWidth={false}>
                    <Button title={'View PDF'} type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} onClickCb={(() => dispatch(viewPDF({
                        formId: row?.FormId,
                        payerId: selectedPayer?.value,
                        formTypeId: selectedForm?.Id,
                    })))}><Icons familyName={'vec'} iconName={VEC_ICON_NAME.VIEW_ICON} /></Button>
                </Loadable>

                {selectedStatus?.status != FORM_STATUS.APPROVED && <Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} title={'Edit'}
                    onClickCb={() => {
                        const queryObj = {
                            FormName: selectedForm?.FormId,
                            Year: row?.TaxYear,
                            FormRecordId: row?.FormId,
                            metaData: JSON.stringify({
                                [EDIT_FORM_ORIGIN]: FORM_SECTION_ROUTES.REVIEW_AND_APPROVE_FORMS,
                                [QUERY_PARAMS.STATUS]: selectedStatus.status
                            })
                        }
                        const queryParamsStr = General.convertObjToQueryString(queryObj)

                        navigate(`/forms/createnew?${queryParamsStr}`)
                    }}
                >
                    <Icons familyName={'vec'} iconName={VEC_ICON_NAME.EDIT_ICON} />
                </Button>}
            </div>
        },
    ];

    return (
        <>
            <div style={commonStyles.dropdownContainer}>
                <div style={commonStyles.selectDropdown}>
                    <Loadable currentState={loadingState.state} loadingStates={[REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_STATUS_LIST_LOADING]} messageMap={REVIEW_AND_APPROVE_FORMS_MESSAGE_MAP} isNewLoadable={true} isFullWidth={false}>
                        <SelectDropdown
                            label="Status *"
                            name="Status"
                            placeHolder="Please select a status"
                            options={statusList}
                            value={selectedStatus}
                            onSelectCb={(name, selectedOption) => {
                                dispatch(setSelectedStatus(selectedOption));

                                if (selectedOption?.value) {
                                    queryParams.set(QUERY_PARAMS.STATUS, selectedOption?.status)
                                } else {
                                    queryParams.delete(QUERY_PARAMS.STATUS)
                                }
                                setQueryParams(queryParams);

                            }}
                        />
                    </Loadable>
                    <Loadable currentState={loadingState.state} loadingStates={[REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_FORMS_LIST_LOADING]} messageMap={REVIEW_AND_APPROVE_FORMS_MESSAGE_MAP} isNewLoadable={true} isFullWidth={false}>
                        <SelectDropdown
                            label="Form *"
                            name="Form"
                            placeHolder="Please select a Form"
                            options={formsList}
                            value={selectedForm}
                            onSelectCb={(name, selectedOption) => {
                                dispatch(setSelectedForm(selectedOption));

                                if (selectedOption?.value) {
                                    queryParams.set(QUERY_PARAMS.FORM_ID, selectedOption?.value)
                                } else {
                                    queryParams.delete(QUERY_PARAMS.FORM_ID)
                                }
                                setQueryParams(queryParams);

                            }}
                        />
                        <SelectDropdown
                            label="Tax Year *"
                            name="TaxYear"
                            placeHolder="Please select a tax year"
                            options={taxYears}
                            value={selectedTaxYear}
                            onSelectCb={(name, selectedOption) => {
                                dispatch(setSelectedTaxYear(selectedOption));

                                if (selectedOption?.value) {
                                    queryParams.set(QUERY_PARAMS.TAX_YEAR, selectedOption?.value)
                                } else {
                                    queryParams.delete(QUERY_PARAMS.TAX_YEAR)
                                }
                                setQueryParams(queryParams);
                            }}
                        />
                    </Loadable>

                    <Loadable currentState={loadingState.state} loadingStates={[REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_PAYERS_LIST_LOADING]} messageMap={REVIEW_AND_APPROVE_FORMS_MESSAGE_MAP} isNewLoadable={true} isFullWidth={false}>
                        <SelectDropdown
                            label="Payer *"
                            name="Payer"
                            placeHolder="Please select a Payer"
                            options={paginatedPayerList.slice(0, payerDropdownPagination.PageSize * (payerDropdownPagination.PageNumber))}
                            onDropdownTouchedToBottomCb={() => {
                                if (payerDropdownPagination.PageSize * (payerDropdownPagination.PageNumber) < paginatedPayerList?.length) {
                                    dispatch(setPayerDropdownPagination({ PageNumber: payerDropdownPagination.PageNumber + 1 }))
                                }
                            }}
                            value={selectedPayer}
                            onSelectCb={(name, selectedOption) => {
                                dispatch(setSelectedPayer(selectedOption));

                                if (selectedOption?.value) {
                                    queryParams.set(QUERY_PARAMS.PAYER_ID, selectedOption?.value)
                                } else {
                                    queryParams.delete(QUERY_PARAMS.PAYER_ID)
                                }
                                setQueryParams(queryParams);
                            }}
                        />
                    </Loadable>

                    <Button
                        type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER}
                        onClickCb={() => {
                            if (selectedForm?.label && selectedPayer?.value && selectedTaxYear?.value && selectedStatus?.value) {
                                dispatch(reviewAndApproveGridData({
                                    paginationState,
                                    formId: selectedForm?.value,
                                    taxyear: selectedTaxYear?.value,
                                    payerId: selectedPayer?.value,
                                    formstatus: selectedStatus?.status
                                }))
                            } else {
                                dispatch(addNotifications({ heading: "Error", message: "Please select status, form, payer and tax year" }))
                            }
                        }
                        }>Search</Button>
                </div>
            </div>

            {$1099FormsGrid.length ? <div style={commonStyles.buttonContainer}>
                <Button style={commonStyles.button}
                    onClickCb={() => selected1099Forms?.length ? dispatch(setDownloadAllPDFModal(true)) : dispatch(addNotifications({ heading: "Please select a form to download", message: "Please select a form to download multiple PDFs" }))}
                >Download Multiple PDF</Button>

                <Button style={commonStyles.button} onClickCb={() => dispatch(reviewApproveFormsExportToExcel({
                    payerId: selectedPayer?.value,
                    formId: selectedForm?.value,
                    taxyear: selectedTaxYear?.value,
                    status: selectedStatus?.status,
                    formName: selectedForm?.FormLabel,
                }))}>Export To Excel</Button>

                {selectedStatus?.status !== FORM_STATUS.APPROVED && <Button
                    style={commonStyles.button}
                    onClickCb={() => {
                        if (selected1099Forms.length) {
                            dispatch(setApproveFormsModal(true))
                        } else {
                            dispatch(addNotifications({ heading: "Error", message: "Please select recipient details to Approve Form" }))
                        }
                    }}>
                    Approve Form
                </Button>}

                {selectedStatus?.status !== FORM_STATUS.REJECTED && <Button
                    style={commonStyles.button}
                    onClickCb={() => {
                        if (selected1099Forms.length) {
                            dispatch(setRejectFormsModal(true))
                        } else {
                            dispatch(addNotifications({ heading: "Error", message: "Please select recipient details to Reject Form" }))
                        }
                    }}>Reject Form</Button>}
            </div> : null}

            <Loadable
                currentState={loadingState.state}
                loadingStates={[REVIEW_AND_APPROVE_FORMS_LOADING_STATES.FETCHING_GRID_RECORDS_LOADING]}
                messageMap={REVIEW_AND_APPROVE_FORMS_MESSAGE_MAP}
                isNewLoadable={true}
            >
                <RichGrid
                    selectable={true}
                    data={$1099FormsGrid}
                    columns={MANAGE_1099_FORMS_COLUMN}
                    extractRowKey={(row) => row.FormId}
                    selectedRows={selected1099Forms}
                    onHeaderSelectionChangeCallBack={(selectedData) => dispatch(setSelected1099FormsGrid(selectedData))}
                    onSelectionChangeCallBack={(selectedData) => dispatch(setSelected1099FormsGrid(selectedData))}
                    paginationProps={{
                        skip: paginationState?.Skip,
                        take: paginationState?.PageSize,
                        takeOptions: ROW_SELECTION_OPTIONS,
                        total: paginationState?.total,
                        onChangeTakeCb: (newTake) => {
                            dispatch(setPaginationState({ ...paginationState, PageSize: newTake, PageNumber: 1, Skip: 0 }));
                        },
                        onChange: (take, skip) => {
                            dispatch(setPaginationState({ ...paginationState, PageSize: take, Skip: skip, PageNumber: Math.ceil((take + skip) / take) }))
                        }
                    }}
                />
            </Loadable>

            {downloadAllPDFModal &&
                <Popup
                    isPopupOpen={downloadAllPDFModal}
                    childrenStyles={commonStyles.modalBody}
                    onCloseCb={() => dispatch(setDownloadAllPDFModal(false))}
                >
                    <Loadable currentState={loadingState?.state} messageMap={REVIEW_AND_APPROVE_FORMS_MESSAGE_MAP} loadingStates={[REVIEW_APPROVE_FORMS_LOADING_STATES.DOWNLOAD_MULTIPLE_PDF_LOADING]} isNewLoadable={true}>
                        <CheckboxWLabel
                            checked={mergePdfCheckbox}
                            onChangeCb={(e) => dispatch(setMergePdfCheckbox(e.target.checked))}
                            label="To merge all individual form PDF's into a single PDF, check the box and click OK."
                        />

                        <Button
                            style={commonStyles.okButton}
                            onClickCb={() => dispatch(reviewApproveFormsDownloadAllPDF({
                                payerId: selectedPayer?.value,
                                formName: selectedForm?.FormLabel,
                                taxYear: selectedTaxYear?.value,
                                formList: $1099FormsGrid,
                                selectedFormList: selected1099Forms,
                                payerName: selectedPayer?.LastName,
                                mergeCopies: mergePdfCheckbox
                            }))}
                        >
                            Ok
                        </Button>
                    </Loadable>
                </Popup>
            }

            {approveFormsModal &&
                <ConfirmationPopup
                    bodyText={"Would you like to submit these forms now?"}
                    isOpen={approveFormsModal}
                    confirmationButtonProps={{
                        onConfirmationCb: () => dispatch(setApproveFormsModal(false)),
                        confirmationButtonText: "No",
                        confirmationButtonStyles: {},
                        confirmationButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                    }}
                    cancelButtonProps={{
                        onCancelCb: () => dispatch(approveForm({
                            formIds: selected1099Forms.map(f => f.FormId).toString(),
                            payerId: selectedPayer?.value,
                            formName: selectedForm?.FormLabel,
                            payerName: selectedPayer?.LastName,
                            taxyear: selectedTaxYear?.value,
                            paginationState,
                            formId: selectedForm?.value,
                            formstatus: selectedStatus?.status
                        })),
                        cancelButtonText: "Yes",
                        cancelButtonStyles: {},
                        cancelButtonType: BUTTON_TYPE.PRIMARY,
                    }}
                    showClose={false}
                    loaderLoadingStates={REVIEW_AND_APPROVE_FORMS_LOADING_STATES.APPROVE_POPUP_LOADING}
                    loaderMessageMap={REVIEW_AND_APPROVE_FORMS_MESSAGE_MAP}
                    loadingState={loadingState}
                />
            }

            {rejectFormsModal &&
                <Popup
                    title="Notes"
                    isPopupOpen={rejectFormsModal}
                    customPopupHeaderStyles={commonStyles.modalHeaderWTextArea}
                    childrenStyles={commonStyles.modalBodyWTextArea}
                    onCloseCb={() => dispatch(setRejectFormsModal(false))}
                >
                    <Loadable currentState={loadingState?.state} messageMap={REVIEW_AND_APPROVE_FORMS_MESSAGE_MAP} loadingStates={[REVIEW_APPROVE_FORMS_LOADING_STATES.REJECT_FORM_LOADING]} isNewLoadable={true}>
                        <TextArea value={rejectFormRemark} onChangeCb={(e) => dispatch(setRejectFormRemark(e.target.value))} rows={10} placeholder="Enter Remarks (Optional)" />

                        <Button style={commonStyles.okButton} onClickCb={() =>
                            dispatch(rejectForm({
                                formIds: selected1099Forms.map(f => f.FormId).toString(),
                                payerId: selectedPayer?.value,
                                formName: selectedForm?.FormLabel,
                                payerName: selectedPayer?.LastName,
                                taxyear: selectedTaxYear?.value,
                                remarks: rejectFormRemark,
                                paginationState,
                                formId: selectedForm?.value,
                                formstatus: selectedStatus?.status
                            }))
                        }>Ok</Button>
                        <Button style={commonStyles.cancelButton} type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} onClickCb={() => dispatch(setRejectFormsModal(false))}>Cancel</Button>
                    </Loadable>
                </Popup>
            }
        </>
    )
}

export default Forms1099
